/* LEGEND — app root: default UX settings + clock + Terminal.
   (The prototype's tweaks panel becomes Settings later; for now these are the defaults.) */
import React from 'react';
import { Terminal } from './components/Terminal';
import { etClock } from './lib/format';
import { PP } from './lib/perf';

// Defaults that were the prototype's TWEAK_DEFAULTS. These become persisted Settings later.
const T_DEFAULTS = {
  accent: '#4f8cff',
  tone: 'soft',
  density: 'compact',
  pillStyle: 'solid',
  cardStyle: 'float',
  // Position + Ladder placement: 'embedded' welds them to the chart as bands
  // (ribbon top / trade bar bottom); 'floating' keeps the free-card layout.
  dock: 'embedded',
  popoverLayout: 'grid',
  rowStyle: 'badge',
  showLevels: true,
  levelMode: 'main',
  // Ladder when-machine: book histogram style + tape strip visibility.
  ladderHist: 'spine',
  ladderTape: true,
  // Entry marks (components/EntryMarksLayer.tsx): range bars · turning point · tag colour.
  entryMarks: true,
};

export function App({ user }: any) {
  // Header clock, in ET. This was the prototype's fake counter — seeded at 09:41:32
  // and incremented once per tick — so it showed "how long the tab has been open",
  // not the time, and drifted further the longer a session ran. Read the real clock
  // instead. Still a direct textContent poke rather than state: a 1 Hz re-render of
  // the whole terminal is what the quote-flood work went out of its way to avoid.
  React.useEffect(() => {
    const paint = () => {
      const e = document.getElementById('clock');
      if (e) e.textContent = etClock(Date.now()) + ' ET';
    };
    paint();
    const id = setInterval(paint, 1000);
    return () => clearInterval(id);
  }, []);

  // 'Terminal' = the whole tree; nested PP ids inside Terminal break it down.
  return PP('Terminal', React.createElement(Terminal, { t: T_DEFAULTS, user }));
}
